var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "department-permission-row-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "department-permission-row",
        class: {
          "row-odd": _vm.isOdd,
          inactive: !_vm.isActive,
          "blur-row": !_vm.isActive,
        },
      },
      [
        _c(
          "div",
          { staticClass: "target-cell" },
          [
            _c(
              "div",
              { staticClass: "target-info" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticClass: "collapse-toggle",
                    attrs: { ghost: "", small: "" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleExpanded.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.isExpanded ? "expand_less" : "expand_more"
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("i", { staticClass: "material-icons" }, [_vm._v("group")]),
                _vm._v(" "),
                _c("span", { staticClass: "target-name" }, [
                  _vm._v(_vm._s(_vm.departmentName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "user-count" }, [
                  _vm._v("(" + _vm._s(_vm.departmentUsers.length) + ")"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isActive
              ? _c("SupsisButton", {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Yetki Ver" },
                      expression: "{ content: 'Yetki Ver' }",
                    },
                  ],
                  attrs: { ghost: "", primary: "", icon: "add", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("activate", _vm.department._id)
                    },
                  },
                })
              : _c("SupsisButton", {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Yetkiyi Kaldır" },
                      expression: "{ content: 'Yetkiyi Kaldır' }",
                    },
                  ],
                  attrs: {
                    ghost: "",
                    danger: "",
                    icon: "remove_circle",
                    small: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("deactivate", _vm.department._id)
                    },
                  },
                }),
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.scopeGroups, function (group) {
          return _c("div", { key: group.id, staticClass: "scope-group-cell" }, [
            _c(
              "div",
              { staticClass: "scope-toggles" },
              _vm._l(group.scopes, function (scope) {
                return _c(
                  "div",
                  {
                    key: scope,
                    staticClass: "scope-toggle-cell",
                    on: {
                      click: function ($event) {
                        _vm.isActive && _vm.toggleScope(scope)
                      },
                    },
                  },
                  [
                    _c(
                      "SupsisButton",
                      {
                        class: { "scope-active": _vm.hasScope(scope) },
                        attrs: { disabled: !_vm.isActive },
                      },
                      [
                        _vm.hasScope(scope)
                          ? _c("i", { staticClass: "material-icons" }, [
                              _vm._v("done"),
                            ])
                          : _c(
                              "div",
                              {
                                staticClass: "disabled-item",
                                on: {
                                  mouseenter: function ($event) {
                                    _vm.isActive &&
                                      _vm.hoverEffect($event, true)
                                  },
                                  mouseleave: function ($event) {
                                    _vm.isActive &&
                                      _vm.hoverEffect($event, false)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("done"),
                                ]),
                                _vm._v(" "),
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("circle"),
                                ]),
                              ]
                            ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.isExpanded && _vm.departmentUsers.length > 0
      ? _c(
          "div",
          { staticClass: "department-users" },
          _vm._l(_vm.departmentUsers, function (user, index) {
            return _c("DepartmentUserRow", {
              key: "dept-user-" + user._id,
              attrs: {
                user: user,
                "department-scopes": _vm.target ? _vm.target.scopes : [],
                "user-target": _vm.getUserTarget(user),
                "scope-groups": _vm.scopeGroups,
                "is-department-active": _vm.isActive,
              },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }